import { render } from "./YearsBeforeChart.vue?vue&type=template&id=2b046503"
import script from "./YearsBeforeChart.vue?vue&type=script&lang=js"
export * from "./YearsBeforeChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Charts/YearsBeforeChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b046503"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b046503', __exports__)) {
    api.reload('2b046503', __exports__)
  }
  
  module.hot.accept("./YearsBeforeChart.vue?vue&type=template&id=2b046503", () => {
    api.rerender('2b046503', render)
  })

}


export default __exports__